export default __webpack_public_path__ + "static/media/ContainerPlaceholder.08e03214.png";